import React from 'react';
import eth1 from '../assets/eth1.png';
import eth2 from '../assets/eth2.png';

export default function Like() {
  return (
    <div className='like'>
      <div className="container">
        <div className="content">
          <div className="image">
            <img src={eth1} alt="eth1" />
          </div>
          <h2 className="title">Lorem ipsum dolor sit amet.</h2>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, modi dolore. Quasi minus deleniti quam?</p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, modi dolore. Quasi minus deleniti quam?</p>
        </div>
        <div className="content">
          <div className="image">
            <img src={eth2} alt="eth1" />
          </div>
          <h2 className="title">Lorem ipsum dolor sit amet.</h2>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, modi dolore. Quasi minus deleniti quam?</p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus, modi dolore. Quasi minus deleniti quam?</p>
        </div>
      </div>
    </div>
  )
}
